import { message } from 'antd';
import { subMonths } from 'date-fns';
import { formatDate } from 'src/utils/date-util';
import { getStoreIssuesForStoreWithWhere } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const monthRange = 6;
const getStoreIssues = async (storeCode: string) => {
  const now = new Date();
  const endDate = formatDate(subMonths(now, monthRange), "yyyy-MM-dd'T'HH:mm:ss+0900");

  return getStoreIssuesForStoreWithWhere(
    [
      ['storeCode', '==', storeCode],
      ['isDeleted', '==', false],
      ['date', '>=', endDate],
    ],
    {
      sortKey: 'date',
      orderBy: 'desc',
    }
  );
};

const useStoreIssues = (storeCode: string | null) => {
  const { data, error } = useSWR(storeCode, getStoreIssues, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });
  const storeIssues = data?.filter(
    (issue) => issue.message && issue.message.trim().length > 0 && issue.status === '완료'
  );

  if (error) {
    console.error(error);
    message.error(error.message);
  }

  return {
    storeIssues,
  };
};

export default useStoreIssues;
